import axios from '@/libs/http'

/**
 * 获取我的资料
 */
export const getMyGradeData = () => {
  return axios.request({
    url: '/s/c/grade/get',
    params: {
    },
    method: 'get'
  })
}

